import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// pipe puro: angular solo vuelve a ejecutar transform() cuando cambian sus
// argumentos (por referencia/valor), a diferencia de un metodo de componente
// que se ejecuta en cada ciclo de deteccion de cambios de toda la app
@Pipe({ name: 'resaltarPalabraClave' })
export class ResaltarPalabraClavePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(
    texto: string,
    idPractica: any,
    palabrasClave: string[],
    idsCoincidentes: string[],
  ): SafeHtml {
    const textoSeguro = (texto || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    const esCoincidencia =
      !!idsCoincidentes &&
      idsCoincidentes.length > 0 &&
      idPractica != null &&
      idsCoincidentes.indexOf(idPractica.toString()) !== -1;

    if (!palabrasClave || !palabrasClave.length || !esCoincidencia) {
      return this.sanitizer.bypassSecurityTrustHtml(textoSeguro);
    }

    const terminos = palabrasClave
      .map((p) => (p || '').trim())
      .filter(Boolean)
      .map((p) => p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      .sort((a, b) => b.length - a.length); // terminos mas largos primero para no cortar coincidencias parciales

    if (!terminos.length) {
      return this.sanitizer.bypassSecurityTrustHtml(textoSeguro);
    }

    const regex = new RegExp(`(${terminos.join('|')})`, 'gi');
    const resaltado = textoSeguro.replace(
      regex,
      '<mark class="mh-resaltado-palabra-clave">$1</mark>',
    );

    return this.sanitizer.bypassSecurityTrustHtml(resaltado);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/resaltar-palabra-clave.pipe.ts